module.exports = __webpack_public_path__ + "img/7-eleven.653af0e6.png";